import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Antonin Novak",
  title: "Research Engineer at Le Mans University",
  description: `Antonin Novak received the Master degree in radio engineering from the Czech Technical University in Prague in 2006. In 2009, he received a Ph.D. degree in acoustics from the Czech Technical University in Prague and from Le Mans University, Le Mans, France, within the doctoral study under joint supervision. From 2009 he worked as a postdoctoral research fellow at the Laboratoire d’Acoustique de l’Université du Mans, France (LAUM, UMR CNRS 6613). From 2011 to 2014 he worked for Orkidia Audio, France, where he was engaged in the research and development of innovative loudspeaker technology. He is currently a research fellow at Université du Mans, Le Mans, France and is engaged in education and projects in the International Master’s Degree in Electro-Acoustics (IMDEA). His research interests include analysis and measurement of nonlinear systems, electro-acoustics, digital signal processing, acoustics and vibrations, and bio-acoustics.


  <ul>
    <li><a href="https://ant-novak.com/ " target="_blank">https://ant-novak.com/</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/04/authors/antonin-novak.jpg",
};

export default author;
